import React, { Suspense, lazy } from "react";
import { Redirect, Switch, useHistory } from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { DashboardPage } from "./pages/DashboardPage";

// import { useDataContext } from "../redux/ProfileContext";

const RolesPage = lazy(() => import("./modules/Roles/pages/index"));
const UsersPage = lazy(() => import("./modules/Users/pages/index"));
const CounterPage = lazy(() => import("./modules/Counter/pages/index"));
const PropertiesPage = lazy(() => import("./modules/Properties/pages/index"));
const OffersPage = lazy(() => import("./modules/Offers/pages/index"));
const PagesPage = lazy(() => import("./modules/Pages/pages/index"));
const SettingsPage = lazy(() => import("./modules/Settings/pages/index"));
const TicketPriceTypesPage = lazy(() =>
  import("./modules/TicketPriceTypes/pages/index")
);
const TicketPricesPage = lazy(() =>
  import("./modules/TicketPrices/pages/index")
);
const WalletsPage = lazy(() => import("./modules/Wallets/pages/index"));
const CommissionPage = lazy(() => import("./modules/Commission/pages/index"));
const Booking = lazy(() => import("./modules/BookingTickets/pages/index"));
const UpdateProfilePage = lazy(() =>
  import("./modules/Auth/pages/UpdateProfile")
);
const ChangePasswordPage = lazy(() =>
  import("./modules/Auth/pages/ChangePassword")
);

const TransactionPage = lazy(() =>
  import("./modules/Transactions/pages/index")
);
const TicketPage = lazy(() => import("./modules/Tickets/pages/index"));
const TicketHistoryPage = lazy(() =>
  import("./modules/TicketHistory/pages/index")
);

const ScanHistoryPage = lazy(() =>
  import("./modules/ScanHistory/pages/index")
);

const ReportPage = lazy(() => import("./modules/report/pages/index"));
const AccountantPage = lazy(() => import("./modules/Accountant/pages/index"));
const DonationPage = lazy(() => import("./modules/Donation/pages/index"));

export default function BasePage() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  const history = useHistory();
  // const { profiles, loading, getProfileData } = useDataContext();

  const { roleKey } = useSelector(
    (state) => ({
      roleKey: state.auth.role?.key,
    }),
    shallowEqual
  );

  // 🔥 Redirect AFTER role is loaded
  React.useEffect(() => {
    if (!roleKey) return;

    const currentPath = history.location.pathname;

    const routes = {
      COUNTER: "/counters",
      AGENT: "/ticket-history",
      STAFF: "/scan-history",
      SUPER_ADMIN: "/dashboard",
      ACCOUNTED: "/accountant",
      HH: "/dashboard",
      CASHIER: "/accountant",
    };

    const targetRoute = routes[roleKey];

    // Only redirect if:
    // 1. We have a target route for this role
    // 2. The user is currently on the dashboard or root (to avoid loops or blocking navigation)
    // 3. The user is NOT already on the target route
    if (targetRoute && (currentPath === "/dashboard" || currentPath === "/") && currentPath !== targetRoute) {
      history.push(targetRoute);
    }
  }, [history, roleKey]);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Redirect exact from="/" to="/dashboard" />

        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/roles" component={RolesPage} />
        <ContentRoute path="/counters" component={CounterPage} />
        <ContentRoute path="/users" component={UsersPage} />
        <ContentRoute path="/properties" component={PropertiesPage} />
        <ContentRoute path="/offers" component={OffersPage} />
        <ContentRoute path="/pages" component={PagesPage} />
        <ContentRoute path="/reports" component={ReportPage} />
        <ContentRoute path="/settings" component={SettingsPage} />
        <ContentRoute path="/ticket-history" component={TicketHistoryPage} />
        <ContentRoute path="/scan-history" component={ScanHistoryPage} />
        <ContentRoute
          path="/ticket-price-types"
          component={TicketPriceTypesPage}
        />
        <ContentRoute path="/transactions" component={TransactionPage} />
        <ContentRoute path="/tickets" component={TicketPage} />
        <ContentRoute path="/ticket-prices" component={TicketPricesPage} />
        <ContentRoute path="/wallets" component={WalletsPage} />
        <ContentRoute path="/commissions" component={CommissionPage} />
        <ContentRoute path="/update-profile" component={UpdateProfilePage} />
        <ContentRoute path="/change-password" component={ChangePasswordPage} />
        <ContentRoute path="/booking" component={Booking} />
        <ContentRoute path="/accountant" component={AccountantPage} />
        <ContentRoute path="/donations" component={DonationPage} />
        <Redirect to="/error/error-v1" />
      </Switch>
    </Suspense>
  );
}
